interface MetricCardProps {
  label: string;
  value: string | number;
  hint?: string;
  money?: boolean;
}

// Dashboard/summary metric tile — matches the production app's
// `.metric-card` (dark gradient card, large tight number, gold-tinted
// money values).
export function MetricCard({ label, value, hint, money }: MetricCardProps) {
  return (
    <div className="rounded-card border border-ink-border bg-panel-gradient p-4 shadow-card">
      <p className="text-[10px] font-bold uppercase tracking-[0.1em] text-slate-500">{label}</p>
      <p className={`mt-3 font-extrabold tracking-tight ${money ? 'text-2xl text-gold-200' : 'text-3xl text-white'}`}>{value}</p>
      {hint && <p className="mt-1 text-[11px] text-slate-500">{hint}</p>}
    </div>
  );
}
